module.exports = __webpack_public_path__ + "img/gallery_image-3.5af2448.jpg";